<template>
  <div class="detail">
    <div class="detail-banner">
      <div class="container">
        <h1 v-if="product">{{ product.name }}</h1>
        <h1 v-else>Product Details</h1>
        <p v-if="product && product.summary" class="pd-banner-sub">{{ product.summary }}</p>
      </div>
    </div>
    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ Back</span>
        <div class="detail-content" v-if="product">
          <!-- 主图（置顶） -->
          <div class="cover-wrap">
            <img v-if="product.cover" class="detail-cover" :src="product.cover" :alt="product.name" @error="onImgError" />
            <div v-else class="detail-cover cover-fallback">{{ product.name.slice(0, 1) }}</div>
          </div>

          <!-- 类型 / 来源地（移到图片下方） -->
          <div class="pd-tags">
            <span class="pd-tag" v-if="product.category">{{ product.category }}</span>
            <span class="pd-tag" v-if="product.subCategory">{{ product.subCategory }}</span>
            <span class="pd-tag" v-if="product.thirdCategory">{{ product.thirdCategory }}</span>
          </div>
          <div class="pd-source" v-if="product.sourceCountry">
            <span class="pd-source-label">Source</span>
            <span class="pd-source-value">{{ product.sourceCountry }}</span>
          </div>

          <!-- 详细介绍（唯一正文） -->
          <div class="pd-section">
            <div class="pd-section-title">Description</div>
            <div class="rich" v-html="product.content"></div>
          </div>

          <button class="btn-primary pd-consult" @click="consult">Consult Now</button>
        </div>
        <div class="detail-content" v-else-if="!loading">
          Product not found.
        </div>
        <div class="detail-content" v-else>Loading…</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchProductDetail } from '../services/home'

export default {
  name: 'ProductDetail',
  props: ['id'],
  data () {
    return {
      product: null,
      loading: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.product = await fetchProductDetail(this.id)
      } catch (e) {
        this.product = null
        this.$toast.show({ message: (e && e.message) || 'Failed to load', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    onImgError (e) {
      e.target.style.display = 'none'
    },
    consult () {
      this.$router.push('/contact')
    }
  }
}
</script>

<style scoped>
/* 蓝白主题变量（roadlinkglobal 全局调色板，组件内自包含） */
.detail {
  --primary: #265fff;
  --primary-dark: #1a3a5f;
  --primary-light: #4dabf7;
  --blue-soft: #eaf0fe;
  --blue-soft-2: #f4f7fe;
  --text-main: #1f2a44;
  --text-sub: #5b6b8c;
  --border: #e6ebf5;
  --radius: 14px;
  --shadow: 0 6px 22px rgba(38, 95, 255, 0.08);
  background: #f5f7fa;
  min-height: 100vh;
}

.detail-banner {
  background: linear-gradient(135deg, var(--primary-light), var(--primary));
  color: #fff;
  padding: 48px 0 40px;
}
.detail-banner .container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.detail-banner h1 {
  font-size: 30px;
  font-weight: 800;
}
.detail-banner .pd-banner-sub {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.6;
}

.detail-body {
  padding: 0 0 50px;
}
.detail-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 24px 0 20px;
  padding: 9px 18px;
  background: #eef2ff;
  color: var(--primary);
  border: 1px solid #d6e0ff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease;
}
.detail-back:hover {
  background: #dbe4ff;
  transform: translateX(-2px);
}

.detail-content {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 32px;
  box-shadow: var(--shadow);
}
.detail-cover {
  width: 100%;
  height: auto;
  max-height: 420px;
  /* 等比例完整展示：contain 不裁剪，整张图按比例缩放完整呈现 */
  object-fit: contain;
  object-position: center;
  border-radius: 14px;
  display: block;
  padding: 12px;
  box-sizing: border-box;
}
.cover-wrap {
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 26px;
}
.cover-fallback {
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  font-size: 64px;
  font-weight: 800;
}
.pd-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.pd-tag {
  background: var(--blue-soft);
  color: var(--primary);
  font-size: 13.5px;
  font-weight: 700;
  padding: 7px 16px;
  border-radius: 20px;
}
.pd-source {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: var(--blue-soft-2);
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-bottom: 28px;
}
.pd-source-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--primary);
}
.pd-source-value {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-main);
}
.pd-section {
  border-top: 1px solid var(--border);
  padding-top: 24px;
}
.pd-section-title {
  font-size: 18px;
  font-weight: 800;
  color: var(--primary);
  margin-bottom: 16px;
  position: relative;
  padding-left: 14px;
}
.pd-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  width: 4px;
  border-radius: 3px;
  background: linear-gradient(180deg, var(--primary-light), var(--primary));
}
.rich {
  line-height: 1.9;
  color: #33415c;
  font-size: 15px;
}
.rich ::v-deep p {
  margin: 0 0 12px;
}
.pd-consult {
  display: block;
  width: fit-content;
  margin: 30px auto 0;
}
.btn-primary {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 12px 34px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.25s ease;
}
.btn-primary:hover {
  background: var(--primary-dark);
}
</style>
